/**
 * FAQ Section Styling
 * Converts FAQ paragraphs into collapsible accordions
 */

document.addEventListener('DOMContentLoaded', function() {
  // Find the FAQ section
  const faqHeadings = document.querySelectorAll('h2');

  faqHeadings.forEach(heading => {
    const headingText = heading.textContent.toLowerCase();

    if (headingText.includes('faq') || headingText.includes('frequently asked')) {
      // Find the parent section
      const faqSection = heading.closest('.light-background-div, .plp-padding') ||
                         heading.parentElement.parentElement;

      if (faqSection) {
        // Add specific class for styling
        faqSection.classList.add('faq-section-styled');

        // Change heading text to "Frequently Asked Questions"
        const titleSpan = heading.querySelector('span');
        if (titleSpan && titleSpan.textContent.includes('FAQ')) {
          heading.innerHTML = 'Frequently Asked Questions';
        }

        // Find the FAQ items container
        const faqContainer = faqSection.querySelector('.margin-top-30');

        if (faqContainer) {
          // Get all paragraph elements (FAQ items)
          const faqItems = faqContainer.querySelectorAll('p');

          // Create a new container for accordion items
          const accordionContainer = document.createElement('div');
          accordionContainer.className = 'faq-accordion-container';

          faqItems.forEach((item, index) => {
            const strong = item.querySelector('strong');

            if (strong) {
              // Extract question and answer
              let question = strong.textContent.trim();

              // Remove existing Q: prefix if present
              question = question.replace(/^Q:\s*/i, '');

              // Get answer text (everything after the strong tag)
              const itemClone = item.cloneNode(true);
              const strongClone = itemClone.querySelector('strong');
              if (strongClone) {
                strongClone.remove();
              }
              // Remove leading <br> tags
              while (itemClone.firstChild && itemClone.firstChild.nodeName === 'BR') {
                itemClone.firstChild.remove();
              }
              const answer = itemClone.innerHTML.trim();

              // Create accordion details element
              const details = document.createElement('details');
              details.className = 'faq-accordion-item';

              // Open first item by default
              if (index === 0) {
                details.setAttribute('open', '');
              }

              // Create summary (question)
              const summary = document.createElement('summary');
              summary.className = 'faq-accordion-question';
              summary.innerHTML = `<span class="faq-q-prefix">Q:</span> ${question}`;

              // Create answer div
              const answerDiv = document.createElement('div');
              answerDiv.className = 'faq-accordion-answer';
              answerDiv.innerHTML = answer;

              details.appendChild(summary);
              details.appendChild(answerDiv);
              accordionContainer.appendChild(details);
            }
          });

          // Replace the old container content with new accordion
          faqContainer.innerHTML = '';
          faqContainer.appendChild(accordionContainer);
        }
      }
    }
  });
});
